import { v1Api } from '@src/libs/v1Api'
import { ITokenInfoResponse } from '@src/types/tokenInfo'

export const apiGetTokenInfo = async (chainName: string, address: string): Promise<ITokenInfoResponse> => {
    // Always use new token info endpoint
    const { data } = await v1Api.get<ITokenInfoResponse>(
        `v1/tokens/token_info?chain=${chainName}&token_address=${address}`
    )
    return data
}
